export var NAVIGATE_TO_PAGE = "QT-NAVIGATE";
export var BREAKING_NEWS_UPDATED = "QT-BREAKING_NEWS_UPDATED";
export var CLIENT_SIDE_RENDERED = "QT-CLIENT_SIDE_RENDERED";
export var PAGE_LOADING = "QT-PAGE_LOADING";
export var PAGE_FINISHED_LOADING = "QT-PAGE_FINISHED_LOADING";
export var HAMBURGER_CLICKED = "QT-HAMBURGER_CLICKED";
export var HAMBURGER_CLOSED = "QT-HAMBURGER_CLOSED";
export var SERVICE_WORKER_UPDATED = "QT-SERVICE_WORKER_UPDATED";
export var MEMBER_UPDATED = "QT-MEMBER_UPDATED";
export var MEMBER_BEING_LOADED = "QT-MEMBER_BEING_LOADED";
export var SUBSCRIPTION_GROUP_UPDATED = "QT-SUBSCRIPTION_UPDATED";
export var PAYMENT_OPTIONS_UPDATED = "QT-PAYMENT_OPTIONS_UPDATED";
export var ACCESS_BEING_LOADED = "QT-ACCESS_BEING_LOADED";
export var ACCESS_UPDATED = "QT-ACCESS_UPDATED";
export var METER_UPDATED = "QT-METER_UPDATED";
export var ASSET_PLANS = "QT-ASSET_PLANS";
export var CAMPAIGN_SUBSCRIPTION_GROUP_UPDATED = "QT-CAMPAIGN_SUBSCRIPTION_UPDATED";